import styled from 'styled-components';
import { Card } from 'shared-components';

export default styled(Card)`
  display: flex;
  flex-direction: column;
  padding: 40px;
  flex: 1;
`;
